<template>
  <el-table-column
    prop="declutter_reason"
    label="Selejtezés okai"
    show-overflow-tooltip
    min-width="200"
  >
    <template slot-scope="scope">
      {{ getReasons(scope.row.declutter_items) || '-' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'declutter_reason',

    methods: {
      getReasons(items) {
        let mappedItems = items.map(d => d.declutter_reason);
        return [...new Set(mappedItems)].join(', ');
      }
    }
  };
</script>
